module.exports = __webpack_public_path__ + "img/679-4b03f7.png";